import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss']
})
export class NoteComponent implements OnInit {
  @Input() items;
  @Input() title;
  @Input() language;
  @Input() locale;
  @Input() dateformat;

  lateFee = false;

  ngOnInit() {
    if (this.title === 'Late Fee Charge' || this.title === 'Frais pour retard de paiement Facture') {
      this.lateFee = true;
    }
  }
}
